import styled, { createGlobalStyle } from 'styled-components';

/** Standalone the app fills the window and scrolls inside; in UA2 it takes its content height (see embedding). */
export const Frame = styled.div`
  display: flex;
  height: 100%;

  html[data-embedded='true'] & {
    height: auto;
  }
`;

/**
 * In UA2 the frame is as tall as its content and the page scrolls, so the frame itself never scrolls. Without
 * this a popup near the bottom (the page size select) overflowed the frame, its scrollbar narrowed the page,
 * antd re-placed the popup above, the scrollbar went away, and the popup flipped back down in a loop.
 */
export const EmbeddedFrameStyle = createGlobalStyle`
  html[data-embedded='true'],
  html[data-embedded='true'] body {
    overflow: hidden;
  }
`;

export const SideNav = styled.nav`
  width: 200px;
  padding: 24px 16px;
  border-right: 1px solid ${p => p.theme.color.Neutral30};
  background: ${p => p.theme.color.Neutral0};

  a {
    color: ${p => p.theme.color.Neutral80};
    text-decoration: none;
  }

  a.active {
    color: ${p => p.theme.color.Blue100};
  }
  display: flex;
  flex-direction: column;
  gap: 8px;

  a.active {
    font-weight: 600;
  }

  small {
    margin-top: auto;
    color: ${p => p.theme.color.Neutral60};
  }
`;
